<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div class="modal-signup modal-content">

  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Edit Cycle

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-left-0px padding-top-5px">
        <div class="modal-body padding-top-0px  padding-right-0px padding-bottom-0px">

          <div class="row">
            <div class="col-md-3 padding-right-0px bk-color-light2">
              <div class="row">
                <div class="col-md-12 text-align-center padding-left-0px">
                  <label class="margin-bottom-0px font-size-16px color-Assign">{{DisplayName}}</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 text-align-center padding-left-0px line-height-10px">
                  <div [ngSwitch]="Gender">
                    <div *ngSwitchCase="'F'" class="font-size-12px">
                      Female,{{Age}}
                    </div>
                    <div *ngSwitchCase="'M'" class="font-size-12px">
                      Male,{{Age}}
                    </div>
                    <div *ngSwitchCase="'O'" class="td-brorder-8px-blue font-size-12px">
                      Other,{{Age}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12  text-align-center padding-left-0px line-height-17px">
                  <label class="margin-bottom-0px">{{PatientRegNo}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-md-12 padding-right-4px padding-left-0px">
                  <div class="card card-background-transparent border-all-1px border-radius-5px">
                    <div class="card-body padding-all-0px margin-left-0px">
                      <div class="row margin-left-0px">
                        <div class="col-md-5 text-align-right padding-left-0px padding-right-5px">
                          <label class="margin-bottom-0px font-size-12px">Cycle Type</label>
                        </div>:
                        <div class="col-md-5">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{CycleType}}</label>
                        </div>
                      </div>
                      <div class="row margin-left-0px">
                        <div class="col-md-5 text-align-right padding-left-0px padding-right-5px">
                          <label class="margin-bottom-0px font-size-12px">Treatment</label>
                        </div>:
                        <div class="col-md-6">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{ProtocolName}}</label>
                        </div>
                      </div>
                      <div class="row margin-left-0px">
                        <div class="col-md-5 text-align-right padding-left-0px padding-right-5px">
                          <label class="margin-bottom-0px font-size-12px">Culture Info</label>
                        </div>:
                        <div class="col-md-6">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{TCModelName}}</label>
                        </div>
                      </div>
                      <div class="row margin-left-0px">
                        <div class="col-md-5 text-align-right padding-left-0px padding-right-5px">
                          <label class="margin-bottom-0px font-size-12px">Start Date</label>
                        </div>:
                        <div class="col-md-6">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{ProtocolStartDate| date:'MMM-dd-yyyy'}}</label>
                        </div>
                      </div>
                      <div class="row margin-left-0px">
                        <div class="col-md-5 text-align-right padding-left-0px padding-right-5px">
                          <label class="margin-bottom-0px font-size-12px">LMP</label>
                        </div>:
                        <div class="col-md-6 padding-right-0px">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{LMP| date:'MMM-dd-yyyy'}}</label>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>
              
            </div>
            <div class="col-md-9 padding-left-0px">
              <form class="form " novalidate="" #f="ngForm">
                <div class="card margin-top-10">
                  <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-top-0px padding-bottom-0px">
                    <div class="row margin-left-auto">
                      <div class="col-md-12 padding-right-0px">
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-4 text-align-right padding-left-0px">
                                <label for="firstName" class="margin-bottom-0px margin-top-5px">Cycle No</label>
                              </div>
                              <div class="col-md-5">
                                <input type="text" class="form-control" placeholder="Cycle No"
                                       id="UpdatedCycleNo"
                                       [(ngModel)]="UpdatedCycleNo"
                                       name="UpdatedCycleNo" pattern="^[\0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                       maxlength="5" />
                                <small class="form-text text-danger"
                                       *ngIf="(!RecommendedPackage.valid && (RecommendedPackage.dirty || RecommendedPackage.touched) && RecommendedPackage.errors.required )">(Field cannot be left blank)</small>
                                <small class="form-text text-danger"
                                       *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(only numbers are allowed)</small>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row"hidden>
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-4 text-align-right padding-left-0px">
                                <label for="firstName" class="margin-bottom-0px margin-top-5px">Menstrual Cycle</label>
                              </div>
                              <div class="col-md-5">
                                <CodeTypeValue CodeType="MENCY"
                                               id="MenstrualCycle"
                                               [(ngModel)]="MenstrualCycle" SelectedValue=""
                                               name="MenstrualCycle">
                                </CodeTypeValue>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-4 text-align-right padding-left-0px">
                                <label for="firstName" class="margin-bottom-0px margin-top-5px">Treatment Protocol</label>
                              </div>
                              <div class="col-md-5">
                                <CodeTypeValue CodeType="TRPRO"
                                               id="UpdatedProtocolName"
                                               [(ngModel)]="UpdatedProtocolName" SelectedValue=""
                                               name="UpdatedProtocolName">
                                </CodeTypeValue>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-4 text-align-right padding-left-0px">
                                <label for="firstName" class="margin-bottom-0px margin-top-5px">Infertility Type</label>
                              </div>
                              <div class="col-md-5">
                                <CodeTypeValue CodeType="INFRT"
                                               id="UpdatedInfertilityType"
                                               [(ngModel)]="UpdatedInfertilityType" SelectedValue=""
                                               name="UpdatedInfertilityType">
                                </CodeTypeValue>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-4 text-align-right padding-left-0px">
                                <label for="firstName" class="margin-bottom-0px margin-top-5px">End Date</label>
                              </div>
                              <div class="col-md-5">
                                <div class="date-form">
                                  <input class="form-control" placeholder=" Date"
                                         name="dp1" [(ngModel)]="UpdatedProtocolEndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirthEnd="ngModel" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!DateOfBirthEnd.valid && (DateOfBirthEnd.dirty || DateOfBirthEnd.touched) && DateOfBirthEnd.errors.required)">(Field cannot be left blank)</small>
                                  <a (click)="d1.toggle()" class="nav-link-hand">
                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row margin-top-3px">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-4 text-align-right ">
                                <label for="diaplayName">Remarks </label>
                              </div>
                              <div class="col-md-6 padding-right-8px ">
                                <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"
                                          name="UpdatedRemarks"
                                          [(ngModel)]="UpdatedRemarks" required minlength="1" maxlength="100"
                                          #addconcerns_text="ngModel"></textarea>
                                <small class="form-text text-danger"
                                       *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer text-align-center padding-top-10 padding-bottom-10px">
                    <button type="submit"
                            (click)="EditCycle()"
                            class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
                    <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto float-right margin-right-10px"
                            (click)="activeModal.close('Close click')">Close</button>

                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

